export interface loginHelpScreenView {
  loginHelpScreenView: {
    createPasswordButtonText: string;
    createPasswordText: string;
    forgotLoginText: string;
    forgotPasswordText: string;
    headerSubTitle: string;
    headerTitle: string;
    nextDisplayView: {
      button_continue: string;
      button_createPassword: string;
      button_forgotPassword: string;
      button_loginHelp: string;
      button_modal: string;
      button_resetPassword: string;
      button_sendLogin: string;
      button_wfp: string;
      nextViewName: string;
      nextViewName_createPassword: string;
      nextViewName_email: string;
      nextViewName_forgotPassword: string;
      nextViewName_loginHelp: string;
      nextViewName_resetPassword: string;
      nextViewName_sendLogin: string;
      nextViewName_sqa: string;
      overlayMessage: string;
      refreshUrl: string;
    };
    viewName: string;
    logoUrl: string;
    altText: string;
  };
}
